export function normalizeMimeType({
  mimeTypeStr,
}: {
  mimeTypeStr?: string | null;
}): string | undefined {
  if (!mimeTypeStr) return undefined;
  const raw = String(mimeTypeStr).trim();
  if (!raw) return undefined;
  const parts = raw
    .split(";")
    .map(part => part.trim())
    .filter(Boolean);
  const base = parts[0]?.toLowerCase();
  if (!base) return undefined;

  const aliasToCanonical: Record<string, string> = {
    "audio/x-m4a": "audio/mp4",
    "audio/m4a": "audio/mp4",
    "audio/x-mpeg": "audio/mpeg",
    "audio/mp3": "audio/mpeg",
  };

  const canonicalBase = aliasToCanonical[base] ?? base;
  const isPcm = canonicalBase === "application/x-recall-pcm" || canonicalBase === "audio/pcm";

  if (!isPcm) {
    return canonicalBase;
  }

  if (parts.length <= 1) {
    return canonicalBase;
  }

  const params = parts.slice(1).map(part => {
    const [key, ...rest] = part.split("=");
    if (!rest.length) {
      return key.trim().toLowerCase();
    }
    return `${key.trim().toLowerCase()}=${rest.join("=").trim()}`;
  });

  return [canonicalBase, ...params].join(";");
}

export function getFileExtensionFromMimeType({ mimeTypeStr }: { mimeTypeStr: string }): string {
  const normalized = normalizeMimeType({ mimeTypeStr }) ?? mimeTypeStr.toLowerCase();
  const base = normalized.split(";")[0].trim();
  const mimeToExtension: Record<string, string> = {
    "audio/webm": "webm",
    "audio/mp4": "mp4",
    "audio/ogg": "ogg",
    "audio/mpeg": "mp3",
    "audio/aac": "aac",
    "audio/mp3": "mp3",
    "audio/pcm": "pcm",
    "application/x-recall-pcm": "pcm",
  };
  return mimeToExtension[base] || "webm";
}
